<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import PoiDetail from '@/components/shared/CommonDetail.vue'

  export default {
    components: {
      PoiDetail
    },
    data() {
      return {
        // SubscriptionModuleId: this.$route.params.Id,
        CenterLatLong: [53.5463565, 9.9806979], // default
        ZoomLevel: 14, // default,
        MarkerArr: [],
        PageInformation: [],
        attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',      
        defaultCategory: null
      }
    },
    computed: {
      ...mapGetters([
        'MainMenuLayout',
        'AppConfig',
        'ContentPage',
        'SelectedContenttab',
        'resource',
        'POIMarkerAddressArr',       
        'ActiveCategory'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      headerElements() {
        let contentData = this.ContentPage
        let headerElements
        if (contentData.Parent.HeaderElements) {
          headerElements = JSON.parse(contentData.Parent.HeaderElements)
        }
        return headerElements
      },
      footerElements() {
        let contentData = this.ContentPage
        let footerElements
        if (contentData.Parent.FooterElements) {
          footerElements = JSON.parse(contentData.Parent.FooterElements)
        }
        return footerElements
      },
      mapZoomLevel() {
        return this.ZoomLevel
      },
      randomNo() {
        return Helper.getRandomInt()
      },
      onePost() {
        if (this.ContentPage.ContentPages.length === 1 &&
        this.ContentPage.ContentPages[0].Posts.length === 1) {
          return true
        }
        return false
      },
      headerTitle() {
        if (this.onePost) {
          return this.ContentPage.ContentPages[0].Posts[0].Title
        } else {
          return this.ContentPage.Parent.PageTitle
        }
      },
      onePostDetails() {
        if (this.onePost) {
          return this.ContentPage.ContentPages[0].Posts[0]
        } else {
          return {}
        }
      },
      Favorite() {
        if (Helper.IsValid(this.onePostDetails)) {
          this.IsFavorite = Helper.CheckIsFavorite(this.onePostDetails.Id, this.onePostDetails.ModulesContentPages_Id)
        }
        return this.IsFavorite
      },
      IsLike() {
        if (Helper.IsValid(this.onePostDetails)) {
          this.IsLiked = Helper.convertBoolean(this.onePostDetails.IsLiked)
        }
        return this.IsLiked
      },
      AllowLikes() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowLikes)
      },
      AllowAddingToFavorites() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowAddingToFavorites)
      },
      AllowSharing() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowSharing)
      },
      AllowComments() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowComments)
      },
      mapCenterLatLong() {
        return this.CenterLatLong
      },
      POIInitialShowList() {
        return Helper.convertBoolean(this.ContentPage.Parent.POIInitialShowList)
      }
    },
    watch: {
      ContentPage: function(ContentPage) {
        this.PageInformation = ContentPage.ContentPages.filter(page => {
          return page.Posts.sort(function(a, b) { return a.OrderId - b.OrderId })
        })
        // this.mapMarker()
      },
      PageInformation: function(PageInformation) {
        this.defaultCategory = this.POIInitialShowList ? 'List' : 'Map'
        this.mapCenter()
        this.mapMarker()
      }
    },
    async created() {
      await this.initPOIModule(this.SubscriptionModuleId)
      this.defaultCategory = this.POIInitialShowList ? 'List' : 'Map'
    },
    mounted() {
      if (this.$refs.poiPage) {
        this.$refs.poiPage.$on('page:reinit', (event, payload) => {
          this.initPOIModule(this.SubscriptionModuleId)
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.poiPage) {
        this.setActiveCategory('')
        this.$refs.poiPage.$off('page:reinit', (event, payload) => {
          this.initPOIModule(this.SubscriptionModuleId)
        })
      }
    },
    methods: {
      ...mapActions([
        'loadContentPagesLocalData',
        'loadContentPages',
        'getLocationLatLong',
        'addUpdateLike',
        'shareInformation',
        'addMyFavorite',
        'resetContentPageData',
        'setPOIMarkerAddressArr',       
        'setActiveCategory'
      ]),
       tabSelect(tabid) {     
        if (this.ActiveCategory === tabid) {
          return true
        } else if (this.ActiveCategory === '' && this.defaultCategory == tabid) {
           return true
        }
        return false
      },
      onTabSelect (tabid) {
        this.setActiveCategory(tabid)
      },
      async initPOIModule(SubscriptionModuleId) {
        this.$showLoader()
        this.resetContentPageData()
        await this.loadContentPagesLocalData(SubscriptionModuleId)
        await this.loadContentPages(SubscriptionModuleId).then(() => {
          setTimeout(() => {
            if (this.onePost) {
              this.$hideLoader()
              this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': this.onePostDetails.Id, 'ViewType': 2})
            } else {
              this.$hideLoader()
              this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': this.ContentPage.Parent.Id, 'ViewType': 1})
            }
          }, 1000)
          // this.mapCenter()
          // this.mapMarker()
        }).catch(err => {
          console.log('err', err)
          // this.$f7.mainView.loadContent()
          this.$hideLoader()
        })
      },
      mapCenter: async function() {
        let contentData = this.ContentPage
        let centerLatLong
        if (!Helper.IsNullOrEmpty(contentData.Parent.POIInitalMapLocation)) {
          let maplocation = contentData.Parent.POIInitalMapLocation
          this.CenterLatLong = maplocation.split(',')
          // centerLatLong = await this.getLatLong(Helper.replaceRN(contentData.Parent.POIInitalMapLocation))
        } else if (contentData.ContentPages.length > 0) {
          centerLatLong = await this.getLatLong(Helper.replaceRN(contentData.ContentPages[0].Posts[0].MapAddressLine1))
        }
        if (Helper.IsValid(centerLatLong)) {
          this.CenterLatLong = [centerLatLong.y, centerLatLong.x]
        }
        if (Helper.IsValid(contentData.Parent.POIInitialZoomLevel)) {
          this.ZoomLevel = contentData.Parent.POIInitialZoomLevel
        }
        return this.CenterLatLong
      },
      getLatLong: async function(location) {
        let LatLong
        if (!Helper.IsNullOrEmpty(location)) {
          let addressprivious = this.POIMarkerAddressArr.find(addres => addres.location === location)
          if (addressprivious) {
            LatLong = addressprivious.LatLong
          } else {
            // LatLong = await this.getLocationLatLong(Helper.replaceRN(location))
            // this.POIMarkerAddressArr.push({'location' : location, 'LatLong': LatLong})
            // this.setPOIMarkerAddressArr(this.POIMarkerAddressArr)
          }
        }
        if (Helper.IsValid(LatLong) && LatLong.length > 0) {
          LatLong = LatLong[0]
        }
        return LatLong
      },
      mapMarker: async function() {
        let markerArray = []
        this.$showLoader()
        for (let i = 0; i < this.PageInformation.length; i++) {
          for (let j = 0; j < this.PageInformation[i].Posts.length; j++) {
            if (!Helper.IsNullOrEmpty(this.PageInformation[i].Posts[j].MapAddressLine2)) {
              // let maddLine2 = await this.getLatLong(this.PageInformation[i].Posts[j].MapAddressLine2)
              // if (Helper.IsValid(maddLine2)) {
              //   markerArray.push({
              //     lat: maddLine2.y,
              //     lng: maddLine2.x,
              //     address: this.PageInformation[i].Posts[j].MapAddressLine2,
              //     detailurl: this.poiDetailUrl(this.PageInformation[i].Posts[j].Id)
              //   })
              // }
              let maddLine2 = this.PageInformation[i].Posts[j].MapAddressLine2.split(',')
              if (maddLine2.length > 1) {
                markerArray.push({
                  lat: maddLine2[0],
                  lng: maddLine2[1],
                  address: this.PageInformation[i].Posts[j].MapAddressLine1,
                  detailurl: this.poiDetailUrl(this.PageInformation[i].Posts[j].Id, 'Map')
                })
              }
            }
            // else if (!Helper.IsNullOrEmpty(this.PageInformation[i].Posts[j].MapAddressLine1)) {
            //   let maddLine1 = await this.getLatLong(this.PageInformation[i].Posts[j].MapAddressLine1)
            //   if (Helper.IsValid(maddLine1)) {
            //     markerArray.push({
            //       lat: maddLine1.y,
            //       lng: maddLine1.x,
            //       address: this.PageInformation[i].Posts[j].MapAddressLine1,
            //       detailurl: this.poiDetailUrl(this.PageInformation[i].Posts[j].Id)
            //     })
            //   }
            // }
          }
        }
        this.MarkerArr = markerArray
        this.$hideLoader()
        return markerArray
      },
      poiDetailUrl: function(value, cat) {
        return '/poi-detail-view/' + this.SubscriptionModuleId + '/' + value + '?cat='+ cat
      },
      IsValid: function(value) {
        return Helper.IsValid(value)
      },
      media: function(value) {
        if (!Helper.IsNullOrEmpty(value)) {
          return `<div class="cover-background list-cover-image" style="background-image: url(${this.AppConfig.Urls.ContentAssetsBaseUrl + value})"></div>`
        } else {
          return ''
        }
      },
      subtitle: function(noOflike, noOfComment) {
        if (this.AllowLikes && this.AllowComments) {
          return '<div class="headerOption__item"><span>' + noOflike + '<span class="icon-dislike-them-color"></span></span> <span>' + noOfComment + '<span class="icon-comment"></span></span></div>'
        } else if (this.AllowLikes) {
          return '<div class="headerOption__item"><span>' + noOflike + '<span class="icon-dislike-them-color"></span></span></div>'
        } else if (this.AllowComments) {
          return '<div class="headerOption__item"><span>' + noOfComment + '<span class="icon-comment"></span></span></div>'
        }
      },
      description: function(MapAddressLine1, MapAddressLine2) {
        // if (!Helper.IsNullOrEmpty(MapAddressLine1) && !Helper.IsNullOrEmpty(MapAddressLine2)) {
        //   return MapAddressLine1 + '<br/>' + MapAddressLine2
        // } else
        if (!Helper.IsNullOrEmpty(MapAddressLine1)) {
          return MapAddressLine1
        }
        // else if (!Helper.IsNullOrEmpty(MapAddressLine2)) {
        //   return MapAddressLine2
        // }
      },
      openDetails(detailurl) {
        this.$f7.views.main.router.navigate(detailurl)
      },
      onLikeClick() {
        let Like = {
          ModulesContentPages_Id: this.onePostDetails.ModulesContentPages_Id,
          Reference_Id: this.onePostDetails.Id,
          Liked: !Helper.convertBoolean(this.onePostDetails.IsLiked),
          AppGUID: this.AppConfig.AppGUID,
          ContentType: 1,
          NotificationContent: {
            Title: this.onePostDetails.Title,
            ImageName: this.onePostDetails.PostImage,
            Comment: '',
            Navigationurl: this.poiDetailUrl(this.onePostDetails.Id)
          }
        }
        this.addUpdateLike(Like).then(() => {
          this.$f7.notification.create({
            title: Helper.convertBoolean(this.onePostDetails.IsLiked) ? this.resource.likeSuccesTitle : this.resource.disLikeSuccesTitle,
            subtitle: Helper.convertBoolean(this.onePostDetails.IsLiked) ? this.resource.likeSuccesMessage : this.resource.disLikeSuccesMessage,
            cssClass: 'success-notification',
            closeOnClick: true,
            closeTimeout: 3000
          }).open()
        })
        // this.addUpdateLike(Like)
      },
      onShareCLick() {
        // let files = []
        // if (Helper.IsValid(this.onePostDetails.PostImage)) {
        //   files.push(this.AppConfig.Urls.ContentAssetsBaseUrl + this.onePostDetails.PostImage)
        // }
        // let Options = {
        //   message: 'Please check out this Location which I have found',
        //   subject: 'I have found an interesting Location, please check',
        //   files: files,
        //   url: Helper.CurrentWebAppLocation(this.AppConfig.Urls.ContentBaseUrl, this.AppConfig.Subscription_GUID)
        // }
        // this.shareInformation(Options)
        let Options = {
          appConfig: this.AppConfig,
          moduleId: this.ContentPage.Parent.Module_Id,
          subscriptionModuleId: this.ContentPage.Parent.SubscriptionModule_Id,
          shareId: this.onePostDetails.Id,
          path: Helper.CurrentlocationURL(),
          orderId: 0
        }
        this.shareInformation(Options)
      },
      onFavoriteClick() {
        let favData = {
          Reference_Id: this.onePostDetails.Id,
          ReferenceParent_Id: this.onePostDetails.ModulesContentPages_Id
        }
        this.addMyFavorite(favData)
        this.IsFavorite = Helper.CheckIsFavorite(this.onePostDetails.Id, this.onePostDetails.ModulesContentPages_Id)
      }
    }
  }
</script>

<template>
  <f7-page ref="poiPage" :page-content="false" :name="'poi-view'+ SubscriptionModuleId" v-if="ContentPage">
    <app-header :header="headerTitle" :isShowRightNavBar="!onePost"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1 && !onePost"></app-tab-menu>
    <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
    <app-floating-button v-if="onePost && onePostDetails"
      :ShowLike="AllowLikes"
      :ShowFavorite="AllowAddingToFavorites"
      :ShowShare="AllowSharing"
      :IsLike="IsLike"
      :IsFavorite="Favorite"
      :onLikeClick="onLikeClick"
      :onFavoriteClick="onFavoriteClick"
      :onShareCLick="onShareCLick"
    ></app-floating-button>
    <div class="backgroundimg"></div>
    <f7-page-content v-if="!onePost && ContentPage.ContentPages">
      <f7-segmented class="map-segmented">
        <template v-if="!POIInitialShowList && defaultCategory != null">
          <f7-button :tab-link="'#tab-map'+randomNo" @click="onTabSelect('Map')" :tabLinkActive="tabSelect('Map')">{{resource.map}}</f7-button>
          <f7-button :tab-link="'#tab-list'+randomNo" @click="onTabSelect('List')" :tabLinkActive="tabSelect('List')">{{resource.list}}</f7-button>      
        </template>
        <template v-else>
          <f7-button :tab-link="'#tab-list'+randomNo" @click="onTabSelect('List')" :tabLinkActive="tabSelect('List')">{{resource.list}}</f7-button>      
          <f7-button :tab-link="'#tab-map'+randomNo" @click="onTabSelect('Map')" :tabLinkActive="tabSelect('Map')">{{resource.map}}</f7-button>
        </template>
      </f7-segmented>
      <f7-tabs class="map-tabs-outer">
        <f7-tab :id="'tab-map'+randomNo" class="map-tabs-inner" :tab-active="tabSelect('Map')">
          <div class ="mapWrapper" v-if="ContentPage.ContentPages && tabSelect('Map')">
            <v-map :zoom="mapZoomLevel" :center="mapCenterLatLong">
              <v-tilelayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" :attribution="attribution"></v-tilelayer>
              <template v-for="(mark,index) in MarkerArr">
                <v-marker  v-if="IsValid(mark.lat)" :lat-lng="[mark.lat, mark.lng]" :key="index" v-on:l-click="openDetails(mark.detailurl)">
                </v-marker>
              </template>
              <!-- <v-tooltip :content="mark.address"></v-tooltip> -->
              <!-- <v-popup :content="mark.address"></v-popup> -->
            </v-map>
          </div>
        </f7-tab>
        <f7-tab :id="'tab-list'+randomNo" class="list-tab-div" :tab-active="tabSelect('List')">
          <div v-if="headerElements" class="header-section">
            <component v-for="(el,index) in headerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
            </component>
          </div>
          <div v-for="(Posts, index1) in PageInformation" :key="index1">
            <f7-list media-list>
              <f7-list-item
                v-for="(PostDetails, index) in Posts.Posts"
                :key="index"
                :link="poiDetailUrl(PostDetails.Id, 'List')"
                :title="PostDetails.Title"
                :text="description(PostDetails.MapAddressLine1, PostDetails.MapAddressLine2)">
                <!-- :media="media(PostDetails.PostImage)"
                :subtitle="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)" -->
                <div v-if="media(PostDetails.PostImage)" slot="media" v-html="media(PostDetails.PostImage)"></div>
                <div slot="subtitle" v-html="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)"></div>
              </f7-list-item>
            </f7-list>
          </div>
          <div v-if="footerElements" class="footer-section">
            <component v-for="(el,index) in footerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
            </component>
          </div>
        </f7-tab>
      </f7-tabs>
    </f7-page-content>
    <poi-detail v-if="onePost && ContentPage.ContentPages" :Parent="ContentPage.Parent" :PostDetails="onePostDetails" :SubscriptionModuleId="SubscriptionModuleId" IsFrom="POI"></poi-detail>
  </f7-page>
</template>
<style scoped>
  .list-block {
    margin: 10px 0;
  }
  .floating-button-toolbar, .speed-dial{
    bottom: 15px!important;
  }
  .mapWrapper{
    width : 100%;
    height: 83%;
    position: fixed;
  }
  .ios .mapWrapper{
    height: calc(100% - 84px);
  }
  .ios.device-iphone-x .mapWrapper {
    height: calc(100% - 118px);
  }
  .ios .list-tab-div {
    height:100%;
  }
  .map-segmented {
    margin: 10px 15%;
  }
  .md .map-segmented {
    border: 1px solid #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/poi/POI.vue